// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"ab812e48","86":"4f8bf77a"}[chunkId] + ".chunk.css";
};